import { ibkApi } from '@ibk/shared-config';
const BACKEND_STATUS_TO_SHIPMENT = {
    PROCESSING: 'IN_PRODUCTION',
    SENT: 'IN_TRANSIT',
    RECEIVED: 'DELIVERED',
    CANCELED: 'CANCELED',
};
export function mapBackendTrackingStatus(status) {
    if (!status) {
        return 'IN_PRODUCTION';
    }
    return BACKEND_STATUS_TO_SHIPMENT[status] ?? 'IN_PRODUCTION';
}
export function mapCardTrackingItem(item) {
    return {
        cardTrackingId: item.cardTrackingId,
        trackingCode: item.trackingCode ?? '',
        trackingUrl: item.deliveryCarrierUrl ?? '',
        status: mapBackendTrackingStatus(item.status),
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
    };
}
export const buildListCardTrackingsQuery = ({ contractId, trackingCode, limit, offset }) => ({
    url: `/v1/benefits/contracts/${contractId}/trackings`,
    method: 'GET',
    params: {
        ...(trackingCode && { trackingCode }),
        ...(limit !== undefined && { limit }),
        ...(offset !== undefined && { offset }),
    },
});
export const transformListCardTrackingsResponse = (response, meta) => {
    const items = (response.result ?? []).map(mapCardTrackingItem);
    const totalHeader = meta?.response?.headers?.get('X-Total-Count');
    const parsedTotal = totalHeader ? Number(totalHeader) : items.length;
    return {
        result: items,
        total: Number.isNaN(parsedTotal) ? items.length : parsedTotal,
    };
};
export const buildGetCardTrackingDetailQuery = ({ contractId, cardTrackingId }) => ({
    url: `/v1/benefits/contracts/${contractId}/trackings/${cardTrackingId}`,
    method: 'GET',
});
export const contractCardTrackingsApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        listEmissorCardTrackings: build.query({
            query: buildListCardTrackingsQuery,
            transformResponse: transformListCardTrackingsResponse,
        }),
        getEmissorCardTrackingDetail: build.query({
            query: buildGetCardTrackingDetailQuery,
            transformResponse: (response) => response.result,
        }),
    }),
    overrideExisting: false,
});
export const { useGetEmissorCardTrackingDetailQuery, useListEmissorCardTrackingsQuery } = contractCardTrackingsApi;
